export const validateDate = (date: string | Date): boolean => {
  const d = new Date(date);
  if (d instanceof Date && !isNaN(d.getTime())) return true;
  return false;
};
